import { useBroadcastChannel } from "@app-context/broadcastChannels/context";
import { MethodsWrapper } from "@app-views/Inspector";
import { useRefCallback } from "@enfusion-ui/hooks";
import { getSelectOption } from "@enfusion-ui/utils";
import { Select, TextInput } from "@enfusion-ui/web-components";
import { useThisTab } from "@enfusion-ui/web-core";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";

import {
  HTTPMethod,
  InspectorRestConfig,
  useInspectorContext,
} from "../../context/inspector/context";
import { ActionButton, ButtonArea, PathArea } from "./InspectorConfig";

const REST_METHODS = ["GET", "POST", "PUT", "DELETE", "PATCH"] as const;
const REST_METHOD_OPTIONS = REST_METHODS.map((i) => ({
  label: i,
  value: i,
}));

export const RestConfig: React.FC<{}> = () => {
  const { id } = useThisTab();
  const { config: configBase, setConfig } = useInspectorContext();
  const config = configBase as InspectorRestConfig;

  const { broadcastMessage } = useBroadcastChannel("inspector-channel");

  const handlePathChange = useRefCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setConfig({ ...config, path: e.target.value });
    },
    [config]
  );

  const handleMethodChange = useRefCallback(
    (e: { label: string; value: string } | null) => {
      if (e) setConfig({ ...config, method: e.value as HTTPMethod });
    },
    [config]
  );

  return (
    <>
      <MethodsWrapper>
        <Select
          options={REST_METHOD_OPTIONS}
          value={getSelectOption(REST_METHOD_OPTIONS, config.method)}
          clearable={false}
          onChange={handleMethodChange}
          label="Method"
          minWidth={150}
        />
      </MethodsWrapper>
      <PathArea style={{ minWidth: "300px" }}>
        <TextInput
          hideLabel
          value={config.path}
          onChange={handlePathChange}
          label="Path"
        />
      </PathArea>
      <ButtonArea>
        <ActionButton
          icon={faPaperPlane}
          primary
          onClick={() => broadcastMessage(`${id}<=>send`)}
        >
          Send
        </ActionButton>
      </ButtonArea>
    </>
  );
};
